export default __webpack_public_path__ + "static/media/vkpic2.2130f1b4.png";